// extracted by mini-css-extract-plugin
export default {"account-page":"AccountTypePage_account-page__ro1iL"};